"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxList = CheckboxList;
var react_1 = __importStar(require("react"));
var BlockLabel_1 = require("../../../BlockLabel");
var TextInputs_1 = require("../../../TextInputs");
var _EXPORTS_1 = require("../../../../../utils/_EXPORTS");
var utils_1 = require("../../utils");
var styled_1 = require("../../styled");
var CheckboxInput_1 = require("./comps/CheckboxInput");
var styled_2 = require("./styled");
var Typo2_1 = require("../../../Typo2");
var OKELink_1 = require("../../../OKELink");
var Tags_1 = require("../../../../../components/Tags");
var optionsContainers = {
    checkbox: styled_1.StyledOptionsContainer,
    tagSelect: styled_2.StyledTagOptionsContainer,
};
var convToString = function (value) { return value.map(function (v) { var _a; return (_a = v.display_desc) !== null && _a !== void 0 ? _a : v.value; }); };
function CheckboxList(_a) {
    var id = _a.id, _b = _a.injectOtherOption, injectOtherOption = _b === void 0 ? false : _b, _c = _a.value, valueProp = _c === void 0 ? [] : _c, onChange = _a.onChange, commonIsCorrectDesc = _a.commonIsCorrectDesc, _d = _a.options, options = _d === void 0 ? [] : _d, saveValueAsString = _a.saveValueAsString, _e = _a.inputStyle, inputStyle = _e === void 0 ? 'checkbox' : _e, rightWrongResult = _a.rightWrongResult, _f = _a.listType, listType = _f === void 0 ? 'horizontal' : _f, invert = _a.invert, _g = _a.optionsLimit, optionsLimit = _g === void 0 ? Infinity : _g, style = _a.style, disabled = _a.disabled, className = _a.className, S = _a.S, readOnly = _a.readOnly;
    var props = arguments[0];
    var shouldHideSomeOptions = options.length > optionsLimit;
    var _h = (0, react_1.useState)(false), seeMore = _h[0], setSeeMore = _h[1];
    var _j = (0, utils_1.genDisplayedOptions)({ injectOtherOption: injectOtherOption, options: options, valueProp: valueProp, saveValueAsString: saveValueAsString }), typicalOptions = _j.typicalOptions, injectedOtherOption = _j.injectedOtherOption;
    var value = saveValueAsString ?
        typicalOptions
            .concat(injectedOtherOption || [])
            .filter(function (op) { var _a; return valueProp.includes((_a = op.display_desc) !== null && _a !== void 0 ? _a : op.value); })
        : valueProp;
    var handleTextInputChange = function (text) {
        var newValue = value.map(function (selectedOp) { return (selectedOp.value === 'other' ? (0, utils_1.genOtherValueObject)(text) : selectedOp); });
        if (saveValueAsString)
            newValue = convToString(newValue);
        onChange && onChange(id, newValue);
    };
    var handleCheckboxClick = function (isSelected, option) {
        var newValue = isSelected
            ? value.filter(function (selOp) { return selOp.value !== option.value; })
            : value.concat(option);
        if (saveValueAsString)
            newValue = convToString(newValue);
        onChange(id, newValue);
    };
    var otherOpInSelectees = value.find(function (selectedOp) { return selectedOp.value === 'other'; });
    var InputCommonProps = {
        invert: invert,
        value: value,
        S: S,
        disabled: disabled,
        inputStyle: inputStyle,
        rightWrongResult: rightWrongResult,
        onClick: handleCheckboxClick,
    };
    var OptionsContainer = optionsContainers[inputStyle];
    var blocklabelProps = (0, _EXPORTS_1.getBlockLabelProps)(props);
    return (react_1.default.createElement("div", { className: className, id: id },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, blocklabelProps, { marginBottom: (blocklabelProps === null || blocklabelProps === void 0 ? void 0 : blocklabelProps.sublabel) ? '1.4rem' : '1.2rem' })),
        readOnly ? (react_1.default.createElement(styled_2.StyledDisplayTagsContainer, null, value === null || value === void 0 ? void 0 : value.map(function (selOp) { return react_1.default.createElement(Tags_1.TagDisplay, { key: selOp.value, invert: invert, display: selOp.display_desc || selOp.display }); }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(OptionsContainer, { style: style, listType: listType, S: S }, typicalOptions === null || typicalOptions === void 0 ? void 0 :
                typicalOptions.map(function (option, idx) { return idx < optionsLimit && (react_1.default.createElement(CheckboxInput_1.CheckboxInput, __assign({}, InputCommonProps, { option: option, key: option.value }))); }),
                shouldHideSomeOptions && // if we have the case of off limit options
                    (seeMore || rightWrongResult) && //and decided to show them
                    typicalOptions.slice(optionsLimit).map(function (option) {
                        return react_1.default.createElement(CheckboxInput_1.CheckboxInput, __assign({}, InputCommonProps, { option: option, key: option.value }));
                    }),
                injectOtherOption && injectedOtherOption && ( //so other box and its textInput act as one entity in the flexbox
                react_1.default.createElement(styled_1.StyledOtherOptionContainer, { listType: listType },
                    react_1.default.createElement(CheckboxInput_1.CheckboxInput, __assign({}, InputCommonProps, { option: injectedOtherOption })),
                    otherOpInSelectees && (react_1.default.createElement(styled_1.StyledOtherTextInputWrapper, { listType: listType, rightWrongResult: rightWrongResult },
                        react_1.default.createElement(TextInputs_1.TextInput, { placeholder: "Please Specify Here", value: otherOpInSelectees.display_desc, onChange: function (k, v) { return handleTextInputChange(v); }, disabled: disabled, invert: invert, S: S })))))),
            shouldHideSomeOptions && !rightWrongResult && (react_1.default.createElement(Typo2_1.UI_BODY_BOLD, { style: { marginTop: '1rem' } },
                react_1.default.createElement(OKELink_1.OKELink, { onClick: function () { return setSeeMore(!seeMore); }, children: !seeMore ? 'See More' : 'See Less' }))), /*
              the minute the results have come in, irrespective of user's answers
              being right or wrong, we show an explanation
              below the options. provided that an explanation is provided.
              */
            rightWrongResult && commonIsCorrectDesc &&
                react_1.default.createElement(styled_1.StyledCorrectMessage, { invert: invert }, commonIsCorrectDesc)))));
}
